import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.4899 6.81585C14.317 7.38847 14.317 8.61114 13.4899 9.18376L7.05967 13.6354C6.10462 14.2966 4.80001 13.6131 4.80001 12.4515L4.80001 3.54814C4.80001 2.38655 6.10462 1.703 7.05967 2.36419L13.4899 6.81585Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }